import React from 'react'
import {Box, Typography} from '@mui/material'
import {classes, LinearProgressBar} from '../../PersonaSummary/SummaryComponentStyles'
import PropTypes from 'prop-types'
import {classesIP} from '../selectedPersonaStyles'

const OverviewLinearProgress = ({data}) => {
  return data.map((item, index) => (
    <React.Fragment key={index + item}>
      <Box
        className={classesIP.OverviewLinearProgressBox1}
        tabIndex={0}
        aria-label={`${item.title}, ${Math.round(item.value)}%`}
      >
        <Typography variant="body2" className={classesIP.OverviewLinearProgressText}>
          {item.title}
        </Typography>
        <Box className={[classes.summaryTitleColorTeal, classesIP.OverviewLinearProgressBox2]}>
          <Box className={classesIP.OverviewLinearProgressBox2Child}>
            <LinearProgressBar variant="determinate" value={item.value} />
          </Box>
          <Box className={classesIP.OverviewLinearProgressBox3}>
            <Typography variant="body2">{`${Math.round(item.value)}%`}</Typography>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  ))
}

OverviewLinearProgress.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number,
  data: PropTypes.array.isRequired
}

export default OverviewLinearProgress
